
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { Component, Inject, Prop } from 'vue-property-decorator';
import { formatDate } from '../../../util';
import { paginationOptions, searchOptions } from '../../../util/vue-good-table';
import State from '../State';
import { PqtMeasurementSpecificationTemplate, UserBase } from '../../backend/backendapi';
import { Like } from 'ClientApp/util/Like.js';
import MeasurementSpecificationTemplateDeleteModal from './MeasurementSpecificationTemplateDeleteModal';
import MeasurementSpecificationTemplateEditModal from './MeasurementSpecificationTemplateEditModal';

@Component({
  components: {
    MeasurementSpecificationTemplateEditModal,
    MeasurementSpecificationTemplateDeleteModal,
    VueGoodTable,
  },
})
export default class MeasurementSpecificationTemplates extends Vue {
  @Prop({ default: true })
  readonly editable!: boolean;

  @Inject({ from: 'state' })
  readonly state!: State;

  get columns(): any[] {
    return [
      {
        label: this.$t('productQualityTests.measurementSpecificationTemplate.model.name').toString(),
        field: 'name',
      },
      {
        label: this.$t('productQualityTests.measurementSpecificationTemplate.model.updatedAt').toString(),
        field: 'updatedAt',
        type: 'date',
        formatFn: (updatedAt: Date | undefined) => updatedAt ? formatDate(updatedAt) : '',
      },
      {
        label: this.$t('productQualityTests.measurementSpecificationTemplate.model.updatedBy').toString(),
        field: 'updatedByUser',
        formatFn: (updatedByUser: UserBase | undefined) => this.$t('general.format.firstLastName', {
          firstName: updatedByUser?.firstName ?? '',
          lastName: updatedByUser?.lastName ?? '',
        }),
      },
      {
        label: this.$t('general.actions').toString(),
        field: 'actions',
      },
    ];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  mounted(): void {
    this.state.templatesStore.loadIfAbsent();
  }

  createNew(): void {
    const template = PqtMeasurementSpecificationTemplate.fromJS({ name: '', measurementSpecifications: [] });
    (this.$refs.editModal as MeasurementSpecificationTemplateEditModal).open(template);
  }

  async onClick(arg: { row: Like<PqtMeasurementSpecificationTemplate> }): Promise<void> {
    const template = this.state.templatesStore.templatesById.get(arg.row.id);
    if (!template) {
      return;
    }
    (this.$refs.editModal as MeasurementSpecificationTemplateEditModal).open(template);
  }

  onDelete(template: PqtMeasurementSpecificationTemplate): void {
    (this.$refs.deleteModal as MeasurementSpecificationTemplateDeleteModal).open([template]);
  }

  onEdit(template: PqtMeasurementSpecificationTemplate): void {
    (this.$refs.editModal as MeasurementSpecificationTemplateEditModal).open(template);
  }
}
